import script from "./BenefitsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&setup=true&lang=js"

import "./BenefitsSection.vue?vue&type=style&index=0&id=e7eb0120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7eb0120"]])

export default __exports__